<template>
  <div class="view-register-releases">
    <div class="d-flex justify-content-between align-items-center mb-5">
      <h5 class="text-semibold">
        {{ form.id ? "Editar lançamento" : "Cadastrar lançamento" }}
      </h5>
      <div class="d-flex gap-2">
        <snow-button size="sm" text="Cancelar" @click="back" variant="gray" />
        <snow-button
          size="sm"
          text="Salvar"
          :disabled="!isValid"
          :loading="loadingSubmit"
          @click="submitForm"
        />
      </div>
    </div>

    <div class="my-9 text-center" v-if="loading">
      <b-spinner variant="primary" />
    </div>

    <div v-else class="d-flex flex-lg-row flex-column gap-3">
      <snow-input-file
        v-model="form.cover"
        type="File"
        maxSize="5"
        isImage
        dimensions="800 x 800"
        title="Imagem de lançamento"
        backgroundColor="bg-1"
      />

      <div class="d-flex flex-column gap-5 w-100">
        <snow-input
          v-model="form.name"
          required
          id="name-product"
          label="Nome do produto"
          info="Atenção! Este é o nome que exibiremos para os seus compradores."
          :errors="errors.name"
          :limit="64"
        />

        <snow-input
          v-model="form.url"
          required
          id="name-product"
          label="Adicione a URL da página do seu produto."
          :errors="errors.url"
        />

        <snow-input
          v-model="form.title"
          required
          id="name-releases"
          label="Nome do lançamento"
          info="Este nome aparecerá para seus clientes no card de lançamento na área de membros."
          :errors="errors.title"
          :limit="120"
        />

        <snow-input
          v-model="form.description"
          rows="6"
          type="textarea"
          required
          id="description-product"
          label="Descrição do produto para lançamento"
          info="Esta é a descrição que exibiremos na capa de lançamento do seu produto."
          :errors="errors.description"
          :limit="980"
        />
        <snow-date-picker
          v-model="form.release_at"
          required
          isHours
          format="DD/MM/YYYY HH:mm"
          size="lg"
          id="date"
          label="Data do lançamento"
        />
        <snow-input
          v-model="form.display_days"
          type="number"
          id="standard-time"
          label="Período de exibição na área de membros após o lançamento."
          :errors="errors.display_days"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
import moment from "moment";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loadingSubmit: false,
      ...formFields([
        "cover",
        "name",
        "url",
        "title",
        "description",
        "release_at",
        "display_days"
      ])
    };
  },
  computed: {
    ...mapState("membersReleases", ["releases"]),
    isValid() {
      return (
        this.form.cover &&
        this.form.name &&
        this.form.name.length <= 64 &&
        this.form.url &&
        this.form.title &&
        this.form.description &&
        this.form.description.length <= 980 &&
        this.form.release_at &&
        (!this.form.display_days || this.form.display_days > 0)
      );
    }
  },
  methods: {
    back() {
      this.$router.push({ name: "releases" });
    },
    submitForm() {
      let params = { ...this.form };
      const parsed = moment(
        this.form.release_at,
        ["YYYY-MM-DD HH:mm", "DD/MM/YYYY HH:mm", moment.ISO_8601],
        true
      );

      if (!parsed.isValid()) {
        this.errors.release_at = ["Data inválida"];
        return;
      }

      params.release_at = parsed.format("YYYY-MM-DDTHH:mm");

      if (!params.display_days) {
        params.display_days = null;
      }
      let action = this.$route.params?.id
        ? "membersReleases/put"
        : "membersReleases/post";

      this.loadingSubmit = true;

      this.$store
        .dispatch(action, params)
        .then(() => {
          this.$message.success("O lançamento foi salvo!");
          this.$router.push({ name: "releases" });
        })
        .catch(error => {
          this.$message.error("Erro ao salvar o lançamento");
          this.errors = error.response.data;
          if (
            this.errors.release_at &&
            this.errors.release_at[0].match("Formato inválido")
          )
            this.errors.release_at = ["Formato inválido para data e hora."];
        })
        .finally(() => {
          this.loadingSubmit = false;
        });
    }
  },
  mounted() {
    if (this.$route.params?.id) {
      this.loading = true;

      this.$store
        .dispatch("membersReleases/getById", this.$route.params.id)
        .then(response => {
          const release_at = moment.utc(response.release_at);
          this.form = {
            ...response,
            release_at: release_at.format("DD/MM/YYYY HH:mm")
          };
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style lang="scss" scoped>
.view-register-releases {
  background-color: var(--bg-2);
  padding: 24px;
  border-radius: 16px;
  .icon-angle-right,
  .icon-angle-left {
    font-size: 24px;
    margin-bottom: 3px;
  }

  ::v-deep {
    .form-group {
      padding: 0;
      label {
        color: $neutral-600;
        font-size: 14px;
        margin-bottom: 3px;
      }
      .form-control {
        height: 40px;
        min-height: 40px;
        position: relative;
        border-color: $neutral-300;
        font-size: 16px;
        color: $neutral-900;
      }
      .date-picker-wrapper {
        top: 24px;
      }
    }
  }
}
</style>
